import { EventsActions, SET_SHOW_EVENTS_MODAL } from './events.actions';
import { EventsState } from './events.state';

export const eventsReducer = (state: EventsState, action: EventsActions): EventsState => {
  switch (action.type) {
    case SET_SHOW_EVENTS_MODAL:
      return { ...state, showEventsModal: action.showEventsModal };
    default:
      return state;
  }
};
